import { type FC } from 'react'
import 'swiper/css'
import { SignUpForm } from '~/components/auth/SignUpForm'
import { SiteLayoutV2 } from '~/components/layout/SiteLayoutV2'

const Page: FC = () => {
  return (
    <SiteLayoutV2>
      <SignUpForm />
    </SiteLayoutV2>
  )
}

export default Page
